<template>
	<div>
		<NavBar :admin="true" :items="items" />
		<v-main>
			<v-container>
        <v-btn small fab class="mb-3" color="primary" @click="showNewResult = !showNewResult">
					<v-icon>mdi-plus</v-icon>
				</v-btn>
        <v-card v-if="showNewResult" class="mb-4">
          <v-card-title>
            Novo Resultado
          </v-card-title>
          <v-card-text>
            <RyodorakuResultForm ref="form" :result="newResult" :edit="true" :channels="channels" :qualities="qualities" />
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
						<v-btn color="primary darken-1" text @click="addResult" :loading="addResultLoading">
							<translate>Save</translate>
						</v-btn>
          </v-card-actions>
        </v-card>
        <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
        <template v-else>
          <p v-if="results.length == 0" class="font-weight-thin ml-2">Sem resultados.</p>
          <RyodorakuResult
            v-else 
            v-for="(result, i) in results" :key="i" :result="result" :name="i" class="mb-2" @remove-result="removeResult"
            :channels="channels"
            :qualities="qualities"
          />
        </template>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import RyodorakuResult from "@/components/admin/RyodorakuResult.vue";
import RyodorakuResultForm from "@/components/admin/RyodorakuResultForm.vue";
import axios from "axios";

export default {
  name: "Ryodoraku",
  components: {
    NavBar,
    RyodorakuResult,
    RyodorakuResultForm
  },
  data: () => ({
    loading: false,
    showNewResult: false,
    newResult: {
      note_pt: "",
      note_en: "",
      note_es: "",
      channels: [],
      icds: [],
      points: []
    },
    addResultLoading: false,
    results: [],
    channels: [],
    qualities: []
  }),
  computed: {
		items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: "Ryodoraku",
					disabled: true,
					link: true
				}
			];
		}
	},
  methods: {
    addResult() {
      this.addResultLoading = true;
      axios
        .post("/admin/ryodoraku-results/new", this.newResult)
        .then(response => {
          console.log(response.data);
          this.results.push(response.data.result);
          this.newResult.channels = [];
          this.newResult.icds = [];
          this.$refs.form.reset();
          this.showNewResult = false;
          this.addResultLoading = false;
        })
        .catch(error => {
          console.log(error);
          this.addResultLoading = false;
        });
    },
    removeResult(result) {
      this.results.splice(this.results.indexOf(result), 1);
    }
  },
  created() {
    this.loading = true;
    axios
			.get("/admin/ryodoraku-results")
			.then(response => {
        console.log(response.data);
				if (response.status === 200) {
          this.results = response.data.results;
          this.channels = response.data.channels;
          this.qualities = response.data.qualities;
					this.loading = false;
				}
			})
			.catch(error => console.log(error));
  }
}
</script>